var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "マスタ > 自社",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
            scrollable: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "form",
            {
              staticClass: "main_modal_div",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.updateCompany.apply(null, arguments)
                },
              },
            },
            [
              _vm.errors.length != 0
                ? _c(
                    "div",
                    _vm._l(_vm.errors, function (e) {
                      return _c("ul", { key: e }, [
                        _c(
                          "li",
                          [
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(_vm._s(e)),
                            ]),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("会社名")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.company.company_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.company, "company_name", $$v)
                      },
                      expression: "company.company_name",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("代表者名")]),
                  _vm._v(" "),
                  _c("b-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.company.representative,
                      callback: function ($$v) {
                        _vm.$set(_vm.company, "representative", $$v)
                      },
                      expression: "company.representative",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("郵便番号")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "100px" },
                    attrs: { type: "text", placeholder: "123-4567" },
                    model: {
                      value: _vm.company.zip_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.company, "zip_code", $$v)
                      },
                      expression: "company.zip_code",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticStyle: { width: "110px !important" },
                      on: { click: _vm.searchAddress },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "search" } }),
                      _vm._v("住所検索\n        "),
                    ],
                    1
                  ),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("住所")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.company.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.company, "address", $$v)
                      },
                      expression: "company.address",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("TEL")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.company.tel,
                      callback: function ($$v) {
                        _vm.$set(_vm.company, "tel", $$v)
                      },
                      expression: "company.tel",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("FAX")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.company.fax,
                      callback: function ($$v) {
                        _vm.$set(_vm.company, "fax", $$v)
                      },
                      expression: "company.fax",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("インボイス番号")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "170px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.company.invoice_num,
                      callback: function ($$v) {
                        _vm.$set(_vm.company, "invoice_num", $$v)
                      },
                      expression: "company.invoice_num",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("取引先銀行")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "670px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.company.bank,
                      callback: function ($$v) {
                        _vm.$set(_vm.company, "bank", $$v)
                      },
                      expression: "company.bank",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticStyle: { "margin-left": "20px" },
                      attrs: {
                        type: "submit",
                        variant: "primary",
                        disabled: _vm.pms_master_company < 2,
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { margin: "10px 0px" } }),
            ]
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", [_vm._v("担当者")]),
          _vm._v(" "),
          _c("div", { staticStyle: { overflow: "auto" } }, [
            _c(
              "div",
              { staticStyle: { width: "1200px" } },
              [
                _c("b-table-filter", {
                  attrs: {
                    maxHeight: _vm.maxHeight,
                    filter_list: _vm.filter_list,
                    filter_val: _vm.filter_val,
                    data_list_field: _vm.data_list_field,
                    data_list: _vm.data_list,
                    filter_enable: true,
                    edit_disabled: _vm.pms_master_company < 2,
                  },
                  on: { on_edit: _vm.modalUserShow, on_delete: _vm.delUser },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "5px 0px 0px 0px" } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.data_list.length) + "件  \n      "
              ),
              _c(
                "b-button",
                {
                  ref: "btnShow",
                  staticClass: "icon_btn_w",
                  attrs: {
                    variant: "info",
                    disabled: _vm.pms_master_company < 2,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.modalUserShow(-1)
                    },
                  },
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "plus", "aria-hidden": "true" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-user",
                title: _vm.title,
                "header-bg-variant": "dark",
                "header-text-variant": "light",
                "body-bg-variant": "light",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c("div", { staticClass: "modal_div" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("ログインID")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.login_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "login_id", $$v)
                        },
                        expression: "user.login_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("姓")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "120px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.name1,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name1", $$v)
                        },
                        expression: "user.name1",
                      },
                    }),
                    _vm._v("\n            \n          "),
                    _c("label", [_vm._v("名")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "120px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.name2,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name2", $$v)
                        },
                        expression: "user.name2",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("セイ")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "120px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.name1_kana,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name1_kana", $$v)
                        },
                        expression: "user.name1_kana",
                      },
                    }),
                    _vm._v("\n            \n          "),
                    _c("label", [_vm._v("メイ")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "120px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.user.name2_kana,
                        callback: function ($$v) {
                          _vm.$set(_vm.user, "name2_kana", $$v)
                        },
                        expression: "user.name2_kana",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("販売")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "90px" },
                        model: {
                          value: _vm.user.pms_hanbai,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "pms_hanbai", $$v)
                          },
                          expression: "user.pms_hanbai",
                        },
                      },
                      _vm._l(_vm.sel_pms_list1, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v("\n            \n          "),
                    _c("label", [_vm._v("入金")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "90px" },
                        model: {
                          value: _vm.user.pms_nyukin,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "pms_nyukin", $$v)
                          },
                          expression: "user.pms_nyukin",
                        },
                      },
                      _vm._l(_vm.sel_pms_list2, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v("\n            \n          "),
                    _c("label", [_vm._v("在庫")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "90px" },
                        model: {
                          value: _vm.user.pms_zaiko,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "pms_zaiko", $$v)
                          },
                          expression: "user.pms_zaiko",
                        },
                      },
                      _vm._l(_vm.sel_pms_list2, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("仕入")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "90px" },
                        model: {
                          value: _vm.user.pms_hattyu,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "pms_hattyu", $$v)
                          },
                          expression: "user.pms_hattyu",
                        },
                      },
                      _vm._l(_vm.sel_pms_list2, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v("\n            \n          "),
                    _c("label", [_vm._v("自社")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "90px" },
                        model: {
                          value: _vm.user.pms_master_company,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "pms_master_company", $$v)
                          },
                          expression: "user.pms_master_company",
                        },
                      },
                      _vm._l(_vm.sel_pms_list2, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v("\n            \n          "),
                    _c("label", [_vm._v("発注先")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "90px" },
                        model: {
                          value: _vm.user.pms_master_hattyu_company,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "pms_master_hattyu_company", $$v)
                          },
                          expression: "user.pms_master_hattyu_company",
                        },
                      },
                      _vm._l(_vm.sel_pms_list2, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("顧客")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "90px" },
                        model: {
                          value: _vm.user.pms_master_client_company,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "pms_master_client_company", $$v)
                          },
                          expression: "user.pms_master_client_company",
                        },
                      },
                      _vm._l(_vm.sel_pms_list2, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v("\n            \n          "),
                    _c("label", [_vm._v("商品")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "90px" },
                        model: {
                          value: _vm.user.pms_master_item,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "pms_master_item", $$v)
                          },
                          expression: "user.pms_master_item",
                        },
                      },
                      _vm._l(_vm.sel_pms_list2, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      staticStyle: { "margin-left": "240px" },
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("modal-user")
                        },
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "x" } }),
                      _vm._v("取消\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.updateUser },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.user.id !== null
                ? _c(
                    "div",
                    { staticClass: "form-inline" },
                    [
                      _c("label", [_vm._v("パスワード")]),
                      _vm._v(" "),
                      _c("b-input", {
                        staticStyle: { width: "130px" },
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                        },
                        model: {
                          value: _vm.user.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "password", $$v)
                          },
                          expression: "user.password",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("  再入力")]),
                      _vm._v(" "),
                      _c("b-input", {
                        staticStyle: { width: "130px" },
                        attrs: { type: "password" },
                        model: {
                          value: _vm.user.password_confirmation,
                          callback: function ($$v) {
                            _vm.$set(_vm.user, "password_confirmation", $$v)
                          },
                          expression: "user.password_confirmation",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user.id !== null
                ? _c(
                    "div",
                    {
                      staticClass: "form-inline",
                      staticStyle: { "margin-left": "250px" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticStyle: { width: "200px !important" },
                          attrs: { variant: "primary" },
                          on: { click: _vm.changePassword },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "save" } }),
                          _vm._v(" パスワード変更\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }